import axios from "axios";
import queryString from "query-string";
import {
  ASSETS_SLIDER_PANEL,
  ELEMENTS_SLIDER_PANEL,
  FONTS_COMBINATION_PANEL,
  GIPHY_SLIDER_PANEL,
  GRAPHICS_SLIDER_PANEL,
  ICONS_SLIDER_PANEL,
  IMAGES_SLIDER_PANEL,
  MUSIC_SLIDER_PANEL,
  SAVED_ELEMENTS_PANEL,
  SAVED_TEMPLATES_PANEL,
  TEMPLATES_SLIDER_PANEL,
  VIDEO_SLIDER_PANEL,
} from "../_components/details/constants";
import { batch } from "react-redux";
import * as errorHandlerActions from "./errorHandlerActions";
import {
  ASSETS_ENDPOINT,
  ASSETS_SEARCH_ENDPOINT,
  BRANDFETCH_API_KEY,
  DELETE_ASSET_ENDPOINT,
  DELETE_DOCUMENTS_ENDPOINT,
  DELETE_TEMPLATE_ENDPOINT,
  DOWNLOAD_UNSPLASH_IMAGE_ENDPOINT,
  FETCH_IMAGES_ENDPOINT,
  FETCH_IMAGES_ENDPOINT_PEXELS,
  FETCH_TEXT_BLOCKS,
  FETCH_VIDEOS_ENDPOINT_PEXELS,
  GIPHY_SEARCH_ENDPOINT,
  GIPHY_TRENDING_ENDPOINT,
  GROUP_BY_CATEGORIES,
  GROUP_BY_TEMPLATES,
  ICONS_ENDPOINT_BRANDFETCH,
  ICONS_ENDPOINT_CLEARBIT,
  ICONS_ENDPOINT_ICONS8,
  ICONS_ENDPOINT_NOUN_PROJECT,
  ICONS_SEARCH_ENDPOINT_FLATICON,
  PEXELS_CLIENT_ID,
  PIXABAY_IMAGES_ENDPOINT,
  PIXABAY_VIDEO_ENDPOINT,
  PUBLISH_TEMPLATE,
  SEARCH_BY_TEMPLATE_TYPE,
  SEARCH_GOOGLE_DRIVE,
  SEARCH_IMAGES_ENDPOINT,
  SEARCH_IMAGES_ENDPOINT_PEXELS,
  SEARCH_SHOPIFY,
  STORIES_DETAIL,
  STORYBLOCK_IMAGES_FETCH,
  STORYBLOCK_MUSIC_COLLECTIONS_FETCH,
  STORYBLOCK_MUSIC_SEARCH,
  STORYBLOCK_VIDEOS_FETCH,
} from "./endpoints";
import {
  CHANGE_IMAGE_SOURCE,
  CLEAR_ERRORS,
  CLOSE_ADVANCED_SETTINGS,
  CLOSE_ALL_SLIDERS,
  CLOSE_SIDEBAR,
  CLOSE_SLIDER,
  DELETE_ASSET,
  DELETE_DOCUMENT,
  DELETE_STORY,
  DELETE_TEMPLATE,
  GET_ASSETS,
  GET_ELEMENTS_VIEW_ALL,
  GET_GIPHY,
  GET_ICONS,
  GET_ICONS_VIEW_ALL,
  GET_IMAGES,
  GET_MUSIC,
  GET_TEMPLATE_GROUPS,
  GET_TEXT_BLOCKS,
  GET_VIDEOS,
  GIFSources,
  IconsSources,
  ImageSources,
  MusicSources,
  NAVIGATE_VIEWS,
  OPEN_ADVANCED_SETTINGS,
  OPEN_SIDEBAR,
  OPEN_SLIDER,
  RESET_PAGE,
  SEARCH_ELEMENTS,
  SEARCH_ELEMENTS_ALL,
  SEARCH_GIPHY,
  SEARCH_ICONS,
  SEARCH_IMAGES,
  SET_ABORT_CONTROLLER,
  SET_OR_UPDATE_STYLES,
  SWITCH_MEDIA_TAB,
  TEMPLATE_PUBLISHED,
  VideoSources,
} from "./types";
import { fetchBrandKits } from "./brandKitActions";
import { deleteDocument } from "./aiDocumentActions";
import { analyticsTrackEvent, formatSize } from "../_utils/common";
import { closeBottomPanel } from "./bottomPanelActions";
import { ContentTypes } from "../_utils/constants";
import { showToast } from "../_utils/showToast";
import { t } from "i18next";
import { isActivePanel, isActiveSourceAndPanel } from "../_utils/mediaPanels";
import { isEmpty } from "lodash";

const format = require("string-format");

const cancelRequestsAndSetNewAbortController = () => (dispatch, getState) => {
  // Cancel ongoing requests and assign new abort controller when someone changes media tab
  const { abortController: oldAbortController } = getState().sidebarSlider;
  if (oldAbortController) {
    oldAbortController.abort();
  }
  const abortController = new AbortController();
  dispatch({
    type: SET_ABORT_CONTROLLER,
    payload: abortController,
  });
};

export const setOrUpdateStyles = (performAction, destination) => (dispatch) => {
  dispatch(cancelRequestsAndSetNewAbortController());
  dispatch({
    type: SET_OR_UPDATE_STYLES,
    payload: {
      action: performAction, // page, layer, component
      destination: destination,
    },
  });
};

export const resetSliders = () => {
  return {
    type: CLOSE_ALL_SLIDERS,
  };
};

export const switchMediaTab = (sliderPanelType) => (dispatch, getState) => {
  dispatch(cancelRequestsAndSetNewAbortController());
  dispatch({
    type: SWITCH_MEDIA_TAB,
    payload: sliderPanelType,
  });
};

// Open Sidebar
export const openSidebar = () => {
  return {
    type: OPEN_SIDEBAR,
    payload: {
      isSidebarOpen: true,
    },
  };
};

// Close Sidebar
export const closeSidebar = () => {
  return {
    type: CLOSE_SIDEBAR,
    payload: {
      isSidebarOpen: false,
    },
  };
};

// Open Slider
export const openSlider = (sliderPanelType) => (dispatch) => {
  dispatch(cancelRequestsAndSetNewAbortController());
  dispatch({
    type: OPEN_SLIDER,
    payload: sliderPanelType,
  });
};

// Close Adv settings
export const closeAdvancedSettings = () => {
  return {
    type: CLOSE_ADVANCED_SETTINGS,
  };
};

// Open Slider
export const openAdvancedSettings =
  (panel, selectedTab, aiPromptId, shouldCloseBottomPanel = true) =>
  (dispatch) => {
    batch(() => {
      dispatch({
        type: OPEN_ADVANCED_SETTINGS,
        payload: {
          selectedTab: selectedTab,
          panel: panel,
          aiPromptId: aiPromptId,
        },
      });
      // Whenever advance panel get open close the bottom panel always for better UX
      if (shouldCloseBottomPanel) dispatch(closeBottomPanel());
    });
  };

// Close Slider (It cancel ongoing fetch data requests as well)
export const closeSlider = () => (dispatch) => {
  dispatch(cancelRequestsAndSetNewAbortController());
  dispatch({
    type: CLOSE_SLIDER,
  });
};

export const navigateNow = (payload) => {
  return {
    type: NAVIGATE_VIEWS,
    payload: payload,
  };
};

export const resetPage = (searchText) => {
  return {
    type: RESET_PAGE,
    payload: searchText,
  };
};

export const changeSource = (source) => (dispatch) => {
  dispatch(cancelRequestsAndSetNewAbortController());
  dispatch({
    type: CHANGE_IMAGE_SOURCE,
    payload: source,
  });
};

const fetchImages = (props, signalToken) => (dispatch, getState) => {
  fetch(`${FETCH_IMAGES_ENDPOINT}&page=${props.page}&per_page=20`, {
    signal: signalToken,
  })
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      if (
        !isActiveSourceAndPanel(
          getState,
          IMAGES_SLIDER_PANEL,
          ImageSources.UNSPLASH
        )
      ) {
        return;
      }
      batch(() => {
        dispatch({
          type: GET_IMAGES,
          payload: {
            data: json,
            groupKey: props.groupKey || 0,
            hasMore: true,
            imagesource: ImageSources.UNSPLASH,
          },
        });
        dispatch({ type: CLEAR_ERRORS });
      });
    })
    .catch((error) => {
      dispatch(errorHandlerActions.handleHTTPError(error, props));
    });
};

const fetchImagesFromPexels = (props, signalToken) => (dispatch, getState) => {
  fetch(`${FETCH_IMAGES_ENDPOINT_PEXELS}?page=${props.page}&per_page=20`, {
    signal: signalToken,
    headers: {
      Authorization: `${PEXELS_CLIENT_ID}`,
    },
  })
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      if (
        !isActiveSourceAndPanel(
          getState,
          IMAGES_SLIDER_PANEL,
          ImageSources.PEXELS
        )
      ) {
        return;
      }
      batch(() => {
        dispatch({
          type: GET_IMAGES,
          payload: {
            data: json.photos,
            groupKey: props.groupKey || 0,
            searchText: props.searchText,
            imagesource: ImageSources.PEXELS,
            hasMore: true,
          },
        });
        dispatch({ type: CLEAR_ERRORS });
      });
    })
    .catch((error) => {
      dispatch(errorHandlerActions.handleHTTPError(error, props));
    });
};

const fetchImagesFromPixabay =
  (props, signalToken) => async (dispatch, getState) => {
    fetch(`${PIXABAY_IMAGES_ENDPOINT}&page=${props.page}&per_page=20`, {
      signal: signalToken,
    })
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        if (
          !isActiveSourceAndPanel(
            getState,
            IMAGES_SLIDER_PANEL,
            ImageSources.PIXABAY
          )
        ) {
          return;
        }
        batch(() => {
          dispatch({
            type: GET_IMAGES,
            payload: {
              data: json.hits,
              groupKey: props.groupKey || 0,
              searchText: props.searchText,
              imagesource: ImageSources.PIXABAY,
              hasMore: true,
            },
          });
          dispatch({ type: CLEAR_ERRORS });
        });
      })
      .catch((error) => {
        dispatch(errorHandlerActions.handleHTTPError(error, props));
      });
  };

export const searchImagesOnShutterstock =
  (searchTerm, props, signalToken) => async (dispatch) => {
    // const sstk = require("shutterstock-api");
    // sstk.setAccessToken(process.env.REACT_APP_SHUTTERSTOCK_TOKEN);
    // const imagesApi = new sstk.ImagesApi();
    // const queryParams = {
    //   query: searchTerm,
    //   image_type: "photo",
    //   orientation: "vertical",
    //   people_number: 3,
    //   page: props.page,
    //   per_page: 20,
    // };
    // imagesApi
    //   .searchImages(queryParams)
    //   .then(({ data }) => {
    //     if (data !== null) {
    //       batch(() => {
    //         dispatch({
    //           type: GET_IMAGES,
    //           payload: {
    //             data: data,
    //             groupKey: props.groupKey || 0,
    //             searchText: props.searchText,
    //             imagesource: "Shutterstock",
    //             hasMore: true,
    //           },
    //         });
    //         dispatch({ type: CLEAR_ERRORS });
    //       });
    //     }
    //   })
    //   .catch((error) => {
    //     console.error(error);
    //   });
  };

/**
 *
 * @param {string} searchTerm Search term
 * @param {Object} props Props of parent component where action is injected
 */
const searchImagesOnStoryBlocks =
  (searchTerm, props) => async (dispatch, getState) => {
    const query = queryString.stringify({
      keywords: searchTerm,
      project_id: !isEmpty(props.story?.payload)
        ? props.story?.payload?.id
        : props.document?.data?.id,
      user_id: props.auth?.payload?.selectedOrg,
      page: props.page,
      extended: "description,keywords,aspectRatio,download_formats",
    });
    try {
      const response = await axios.get(`${STORYBLOCK_IMAGES_FETCH}?${query}`);
      if (response.status === 200) {
        if (
          !isActiveSourceAndPanel(
            getState,
            IMAGES_SLIDER_PANEL,
            ImageSources.STORYBLOCKS
          )
        ) {
          return;
        }
        dispatch({
          type: GET_IMAGES,
          payload: {
            data: response.data.results,
            groupKey: props.groupKey || 0,
            searchText: props.searchText,
            imagesource: ImageSources.STORYBLOCKS,
            hasMore: true,
          },
        });
      }
    } catch (error) {
      console.error(`Error in fetching ${props.type || "elements"}!`);
      dispatch(errorHandlerActions.handleHTTPError(error, props));
    }
  };

export const triggerDownload = (meta, signalToken) => () => {
  if (meta?.source !== "Unsplash") {
    return;
  }

  // For unspash we need to trigger download.
  const location = meta?.links?.download_location;

  fetch(format(DOWNLOAD_UNSPLASH_IMAGE_ENDPOINT, location), {
    signal: signalToken,
  })
    .then((response) => {
      return response.json();
    })
    .then((json) => {})
    .catch((error) => {});
};

/* error handling is not done correctly"*/
const searchImages =
  (searchTerm, props, signalToken) => (dispatch, getState) => {
    fetch(
      `${SEARCH_IMAGES_ENDPOINT}&page=${props.page}&per_page=20&query=${searchTerm}`,
      {
        signal: signalToken,
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        if (
          !isActiveSourceAndPanel(
            getState,
            IMAGES_SLIDER_PANEL,
            ImageSources.UNSPLASH
          )
        ) {
          return;
        }
        batch(() => {
          dispatch({
            type: SEARCH_IMAGES,
            payload: {
              data: json.results,
              groupKey: props.groupKey || 0,
              searchText: props.searchText,
              hasMore: props.page + 1 <= json.total_pages,
              imagesource: ImageSources.UNSPLASH,
            },
          });
          dispatch({ type: CLEAR_ERRORS });
        });
      })
      .catch((error) => {
        dispatch(errorHandlerActions.handleHTTPError(error, props));
      });
  };

/* Search Images on Pexels */
const searchImagesOnPexels =
  (searchTerm, props, signalToken) => async (dispatch, getState) => {
    try {
      const response = await fetch(
        `${SEARCH_IMAGES_ENDPOINT_PEXELS}?query="${searchTerm}"&page=${props.page}&per_page=20`,
        {
          signal: signalToken,
          headers: {
            Authorization: `${PEXELS_CLIENT_ID}`,
          },
        }
      );

      const json = await response.json();

      if (json !== null) {
        if (
          !isActiveSourceAndPanel(
            getState,
            IMAGES_SLIDER_PANEL,
            ImageSources.PEXELS
          )
        ) {
          return;
        }
        batch(() => {
          dispatch({
            type: GET_IMAGES,
            payload: {
              data: json.photos,
              groupKey: props.groupKey || 0,
              searchText: searchTerm,
              imagesource: ImageSources.PEXELS,
              hasMore: props.page + 1 <= json.total_results,
            },
          });
          dispatch({ type: CLEAR_ERRORS });
        });
      }
    } catch (error) {
      dispatch(errorHandlerActions.handleHTTPError(error, props));
    }
  };

/* Search Images on Pixabay */
const searchImagesOnPixabay =
  (searchTerm, props, signalToken) => async (dispatch, getState) => {
    try {
      const response = await fetch(
        `${PIXABAY_IMAGES_ENDPOINT}&q=${searchTerm}&page=${props.page}&per_page=20&image_type=photo`,
        {
          signal: signalToken,
        }
      );

      const json = await response.json();
      if (json !== null) {
        if (
          !isActiveSourceAndPanel(
            getState,
            IMAGES_SLIDER_PANEL,
            ImageSources.PIXABAY
          )
        ) {
          return;
        }
        batch(() => {
          dispatch({
            type: GET_IMAGES,
            payload: {
              data: json.hits,
              groupKey: props.groupKey || 0,
              searchText: props.searchText,
              imagesource: ImageSources.PIXABAY,
              hasMore: true,
            },
          });
          dispatch({ type: CLEAR_ERRORS });
        });
      }
    } catch (error) {
      dispatch(errorHandlerActions.handleHTTPError(error, props));
    }
  };

/* Search Images from shopify */
const searchImagesFromShopify =
  (searchTerm, props, signalToken) => (dispatch, getState) => {
    const nextPageToken = props.sidebarSlider.nextPageToken;
    axios
      .post(
        SEARCH_SHOPIFY,
        { cursor: nextPageToken, query: searchTerm },
        { signal: signalToken }
      )
      .then((res) => {
        if (
          !isActiveSourceAndPanel(
            getState,
            IMAGES_SLIDER_PANEL,
            ImageSources.SHOPIFY
          )
        ) {
          return;
        }
        batch(() => {
          dispatch({
            type: GET_IMAGES,
            payload: {
              data: res.data.products.edges,
              groupKey: props.groupKey || 0,
              searchText: props.searchText,
              imagesource: ImageSources.SHOPIFY,
              hasMore: res.data.products.pageInfo.hasNextPage,
              nextPageToken: res.data.products.pageInfo.endCursor,
            },
          });
          dispatch({ type: CLEAR_ERRORS });
        });
      })
      .catch((error) => {
        if (error.response.status === 400) {
          if (error.response.data) {
            dispatch(
              errorHandlerActions.addImageProviderErrors(
                ImageSources.SHOPIFY,
                error.response.data
              )
            );
          }
        } else {
          console.error(`Error in fetching ${props.type || "elements"}!`);
          dispatch(errorHandlerActions.handleHTTPError(error, props));
        }
      });
  };

const searchImagesFromGoogleDrive =
  (searchTerm, props, signalToken) => (dispatch, getState) => {
    const nextPageToken = props.sidebarSlider.nextPageToken;
    const query = queryString.stringify({
      search: searchTerm,
      next_page_token: nextPageToken,
    });
    axios
      .get(SEARCH_GOOGLE_DRIVE + `?${query}`, {
        signal: signalToken,
      })
      .then((res) => {
        if (
          !isActiveSourceAndPanel(
            getState,
            IMAGES_SLIDER_PANEL,
            ImageSources.GOOGLE_DRIVE
          )
        ) {
          return;
        }
        dispatch({
          type: GET_IMAGES,
          payload: {
            data: res.data.files,
            groupKey: props.groupKey || 0,
            searchText: props.searchText,
            imagesource: ImageSources.GOOGLE_DRIVE,
            hasMore: !!res.data.nextPageToken,
            nextPageToken: res.data.nextPageToken,
          },
        });
      })
      .catch((error) => {
        if (error?.response?.status === 400) {
          if (error.response.data) {
            dispatch(
              errorHandlerActions.addImageProviderErrors(
                ImageSources.GOOGLE_DRIVE,
                error.response.data
              )
            );
          }
        } else {
          console.error(`Error in fetching ${props.type || "elements"}!`);
          dispatch(errorHandlerActions.handleHTTPError(error, props));
        }
      });
  };

const fetchAllIconsFromFlaticon =
  (props, signalToken) => (dispatch, getState) => {
    const limit = 30;
    let dataCount = 0;

    let endpoint = `${ICONS_SEARCH_ENDPOINT_FLATICON}?page=${props.page}&limit=${limit}&q=love`;
    axios
      .get(endpoint, {
        signal: signalToken,
      })
      .then((response) => {
        if (
          !isActiveSourceAndPanel(
            getState,
            ICONS_SLIDER_PANEL,
            IconsSources.FLATICON
          )
        ) {
          return;
        }
        dataCount = limit * props.page;

        dispatch({
          type: SEARCH_ICONS,
          payload: {
            data: response.data.data,
            groupKey: props.groupKey || 0,
            hasMore: dataCount >= response.data.metadata.total ? false : true,
            iconsource: IconsSources.FLATICON,
          },
        });
      })
      .catch((error) => {
        dispatch(errorHandlerActions.handleHTTPError(error, props));
      });
  };

const searchIconsOnFlaticon =
  (searchTerm, props, signalToken) => (dispatch, getState) => {
    const limit = 30;
    let dataCount = 0;

    analyticsTrackEvent("searchIcons", {
      keyword: searchTerm,
    });

    let endpoint = `${ICONS_SEARCH_ENDPOINT_FLATICON}?page=${props.page}&limit=${limit}&q=${searchTerm}`;
    axios
      .get(endpoint, {
        signal: signalToken,
      })
      .then((response) => {
        if (
          !isActiveSourceAndPanel(
            getState,
            ICONS_SLIDER_PANEL,
            IconsSources.FLATICON
          )
        ) {
          return;
        }
        dataCount = limit * props.page;

        dispatch({
          type: SEARCH_ICONS,
          payload: {
            data: response.data.data,
            groupKey: props.groupKey || 0,
            hasMore: dataCount >= response.data.metadata.total ? false : true,
            searchText: searchTerm,
            iconsource: IconsSources.FLATICON,
          },
        });
      })
      .catch((error) => {
        dispatch(errorHandlerActions.handleHTTPError(error, props));
      });
  };

/* Search for Logos on Brandfetch */
export const searchIconsOnBrandfetch =
  (searchTerm, props, signalToken) => async (dispatch, getState) => {
    fetch(`${ICONS_ENDPOINT_CLEARBIT}?query=${searchTerm}`, {
      signal: signalToken,
    })
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        let domainName = json[0].domain;
        fetch(`${ICONS_ENDPOINT_BRANDFETCH}`, {
          method: "POST",
          headers: {
            "x-api-key": `${BRANDFETCH_API_KEY}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            domain: domainName,
          }),
        })
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            if (
              !isActiveSourceAndPanel(
                getState,
                ICONS_SLIDER_PANEL,
                IconsSources.BRANDFETCH
              )
            ) {
              return;
            }
            let allLogos = [];
            allLogos.push(json.response.logo);
            dispatch({
              type: GET_ICONS,
              payload: {
                data: allLogos,
                groupKey: props.groupKey || 0,
                hasMore: true,
                iconsource: "Brandfetch",
              },
            });
            dispatch(errorHandlerActions.clearErrors());
          })
          .catch((error) => {
            dispatch(errorHandlerActions.handleHTTPError(error, props));
          });
      })
      .catch((error) => {
        dispatch(errorHandlerActions.handleHTTPError(error, props));
      });
  };

const searchIcons8Icon = (searchTerm = "", props, signalToken) => {};

const fetchIcons8Icon = (props, signalToken) => (dispatch, getState) => {
  if (props.viewAll) {
  } else {
    axios
      .get(`${ICONS_ENDPOINT_ICONS8}/categories`, { signal: signalToken })
      .then((response) => {
        if (
          !isActiveSourceAndPanel(
            getState,
            ICONS_SLIDER_PANEL,
            IconsSources.ICONS8
          )
        ) {
          return;
        }
        dispatch({
          type: GET_ICONS,
          payload: {
            data: response.data.docs,
            groupKey: props.groupKey || 0,
            hasMore: false,
            iconsource: IconsSources.ICONS8,
            searchText: props.searchText,
          },
        });
      })
      .catch((error) => {
        dispatch(errorHandlerActions.handleHTTPError(error, props));
      });
  }
};

const searchNounProjectIcon =
  (searchTerm = "", props, signalToken) =>
  (dispatch, getState) => {
    axios
      .get(
        `${ICONS_ENDPOINT_NOUN_PROJECT}/icons/${
          searchTerm === "" ? "shape" : searchTerm
        }?page=${props.page}`,
        { signal: signalToken }
      )
      .then((response) => {
        if (
          !isActiveSourceAndPanel(
            getState,
            ICONS_SLIDER_PANEL,
            IconsSources.NOUN_PROJECT
          )
        ) {
          return;
        }
        dispatch({
          type: GET_ICONS_VIEW_ALL,
          payload: {
            searchText: searchTerm,
            data: response.data.icons,
            groupKey: props.groupKey || 0,
            hasMore: true,
            iconsource: IconsSources.NOUN_PROJECT,
          },
        });
      })
      .catch((error) => {
        if (error.isAxiosError && error.response.status === 404) {
          dispatch({
            type: GET_ICONS_VIEW_ALL,
            payload: {
              searchText: searchTerm,
              data: [],
              groupKey: props.groupKey || 0,
              type: props.type,
              hasMore: false,
              iconsource: IconsSources.NOUN_PROJECT,
            },
          });
        } else {
          dispatch(errorHandlerActions.handleHTTPError(error, props));
        }
      });
  };

/* error handling is not done correctly"*/
const fetchGiphy = (props, signalToken) => (dispatch, getState) => {
  let limit = 20;
  fetch(
    `${GIPHY_TRENDING_ENDPOINT}&limit=${limit}&offset=${
      (props.page - 1) * limit
    }`,
    { signal: signalToken }
  )
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      if (
        !isActiveSourceAndPanel(getState, GIPHY_SLIDER_PANEL, GIFSources.GIPHY)
      ) {
        return;
      }
      dispatch({
        type: GET_GIPHY,
        payload: {
          data: json.data,
          groupKey: props.groupKey || 0,
          hasMore:
            json.pagination.count + json.pagination.offset <=
            json.pagination.total_count,
          gifSource: GIFSources.GIPHY,
        },
      });
    })
    .catch((error) => {
      dispatch(errorHandlerActions.handleHTTPError(error, props));
    });
};

const searchGiphy =
  (searchTerm, props, signalToken) => (dispatch, getState) => {
    let limit = 20;
    fetch(
      `${GIPHY_SEARCH_ENDPOINT}&q=${searchTerm}&limit=${limit}&offset=${
        props.page * limit
      }&rating=PG&lang=en`,
      { signal: signalToken }
    )
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        if (
          !isActiveSourceAndPanel(
            getState,
            GIPHY_SLIDER_PANEL,
            GIFSources.GIPHY
          )
        ) {
          return;
        }
        dispatch({
          type: SEARCH_GIPHY,
          payload: {
            data: json.data,
            groupKey: props.groupKey || 0,
            searchText: props.searchText,
            hasMore:
              json.pagination.count + json.pagination.offset <=
              json.pagination.total_count,
          },
        });
      })
      .catch((error) =>
        dispatch(errorHandlerActions.handleHTTPError(error, props))
      );
  };

const fetchVideos =
  (searchTerm, props, signalToken) => (dispatch, getState) => {
    let perPage = 20;
    fetch(
      `${PIXABAY_VIDEO_ENDPOINT}&q=${searchTerm}&page=${props.page}&per_page=${perPage}`,
      {
        signal: signalToken,
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        if (
          !isActiveSourceAndPanel(
            getState,
            VIDEO_SLIDER_PANEL,
            VideoSources.PIXABAY
          )
        ) {
          return;
        }
        dispatch({
          type: GET_VIDEOS,
          payload: {
            data: json.hits,
            groupKey: props.groupKey || 0,
            searchText: props.searchText,
            videosource: VideoSources.PIXABAY,
            hasMore: props.page * perPage <= json.total,
          },
        });
      })
      .catch((error) => {
        dispatch(errorHandlerActions.handleHTTPError(error, props));
      });
  };

/* Fetch videos from Pexels */
const fetchVideosFromPexels =
  (searchTerm, props, signalToken) => (dispatch, getState) => {
    fetch(
      `${FETCH_VIDEOS_ENDPOINT_PEXELS}search?query=${searchTerm}&page=${props.page}&per_page=20`,
      {
        signal: signalToken,
        headers: {
          Authorization: `${PEXELS_CLIENT_ID}`,
        },
      }
    )
      .then((response) => response.json())
      .then((json) => {
        if (
          !isActiveSourceAndPanel(
            getState,
            VIDEO_SLIDER_PANEL,
            VideoSources.PEXELS
          )
        ) {
          return;
        }
        dispatch({
          type: GET_VIDEOS,
          payload: {
            data: json.videos,
            groupKey: props.groupKey || 0,
            searchText: props.searchText,
            videosource: VideoSources.PEXELS,
            hasMore: true,
          },
        });
      })
      .catch((error) => {
        dispatch(errorHandlerActions.handleHTTPError(error, props));
      });
  };

/* Fetch videos from Shutterstock */
export const searchVideosOnShutterstock =
  (searchTerm, props) => async (dispatch) => {
    // const sstk = require("shutterstock-api");
    // sstk.setAccessToken(process.env.REACT_APP_SHUTTERSTOCK_TOKEN);
    // const videosApi = new sstk.VideosApi();
    // const queryParams = {
    //   query: searchTerm,
    //   sort: "popular",
    //   page: props.page,
    //   per_page: 20,
    // };
    // videosApi
    //   .searchVideos(queryParams)
    //   .then((data) => {
    //     dispatch({
    //       type: GET_VIDEOS,
    //       payload: {
    //         data: data.data,
    //         groupKey: props.groupKey || 0,
    //         searchText: props.searchText,
    //         videosource: "Shutterstock",
    //         hasMore: true,
    //       },
    //     });
    //   })
    //   .catch((error) => {
    //     console.error(error);
    //   });
  };

/**
 *
 * @param {string} searchTerm Search term
 * @param {Object} props Props of parent component where action is injected
 */
export const searchVideosOnStoryBlocks =
  (searchTerm, props, signalToken) => async (dispatch, getState) => {
    const query = queryString.stringify({
      keywords: searchTerm,
      project_id: props.story?.payload?.id,
      user_id: props.auth?.payload?.selectedOrg,
      page: props.page,
      extended: "description,keywords,durationMs,aspectRatio",
      content_type: "footage",
      quality: "HD",
      max_duration: "60", // Max duration for storyblocks videos
      // quality: "HD,4K", (4K is high resolution which will add extra delay while loading in the editor)
      // content_type: "footage,motionbackgrounds"  (Motion backgrounds are not supported yet.)
    });
    try {
      const response = await axios.get(`${STORYBLOCK_VIDEOS_FETCH}?${query}`, {
        signal: signalToken,
      });
      if (response.status === 200) {
        if (
          !isActiveSourceAndPanel(
            getState,
            VIDEO_SLIDER_PANEL,
            VideoSources.STORYBLOCKS
          )
        ) {
          return;
        }
        dispatch({
          type: GET_VIDEOS,
          payload: {
            data: response.data.results,
            groupKey: props.groupKey || 0,
            searchText: props.searchText,
            videosource: VideoSources.STORYBLOCKS,
            hasMore: true,
          },
        });
      }
    } catch (error) {
      dispatch(errorHandlerActions.handleHTTPError(error, props));
    }
  };

export const searchMusicOnStoryblocks =
  (searchTerm, props, signalToken) => (dispatch, getState) => {
    if (props.viewAll || searchTerm) {
      const limit = 20;
      const query = queryString.stringify({
        categories: props.categoryId,
        project_id: props.story?.payload?.id,
        user_id: props.auth?.payload?.selectedOrg,
        keywords: props.searchText,
        page: props.page,
      });
      axios
        .get(`${STORYBLOCK_MUSIC_SEARCH}?${query}`, { signal: signalToken })
        .then((res) => {
          if (
            !isActiveSourceAndPanel(
              getState,
              MUSIC_SLIDER_PANEL,
              MusicSources.STORYBLOCKS
            )
          ) {
            return;
          }
          const totalResults = res.data.total_results;

          const pageNum = props.page ?? 1;

          dispatch({
            type: GET_MUSIC,
            payload: {
              data: res.data.results,
              groupKey: props.categoryId || 0,
              hasMore: totalResults > pageNum * limit,
              musicSource: MusicSources.STORYBLOCKS,
              searchText: props.searchText,
            },
          });
        })
        .catch((error) => {
          dispatch(errorHandlerActions.handleHTTPError(error, props));
        });
    } else {
      axios
        .get(STORYBLOCK_MUSIC_COLLECTIONS_FETCH, { signal: signalToken })
        .then((res) => {
          dispatch({
            type: GET_MUSIC,
            payload: {
              data: res.data,
              groupKey: props.groupKey || 0,
              hasMore: false,
              musicSource: MusicSources.STORYBLOCKS,
              searchText: props.searchText,
            },
          });
        })
        .catch((error) => {
          dispatch(errorHandlerActions.handleHTTPError(error, props));
        });
    }
  };

export const fetchTextBlocks = (props, signalToken) => (dispatch, getState) => {
  axios
    .get(FETCH_TEXT_BLOCKS, { signal: signalToken })
    .then((res) => {
      if (!isActivePanel(getState, FONTS_COMBINATION_PANEL)) {
        return;
      }
      dispatch({
        type: GET_TEXT_BLOCKS,
        payload: {
          data: res.data.results,
          groupKey: props.groupKey || 0,
          hasMore: res.data.next !== null,
        },
      });
    })
    .catch((error) => {
      dispatch(errorHandlerActions.handleHTTPError(error, props));
    });
};

const fetchAssets = (props, signalToken) => (dispatch, getState) => {
  const page = props.page || 1;

  let url = new URL(ASSETS_SEARCH_ENDPOINT);
  url.searchParams.append("page", page);

  if (props.titleSearchQuery) {
    url.searchParams.append("asset_key__contains", props.titleSearchQuery);
  }

  axios
    .get(url.href, {
      signal: signalToken,
    })
    .then((res) => {
      if (!isActivePanel(getState, ASSETS_SLIDER_PANEL)) {
        return;
      }
      dispatch({
        type: GET_ASSETS,
        payload: {
          data: res.data.results,
          groupKey: props.groupKey || 0,
          hasMore: res.data.next !== null,
        },
      });
    })
    .catch((error) => {
      dispatch(errorHandlerActions.handleHTTPError(error, props));
    });
};

const deleteAsset = (props, signalToken) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(format(DELETE_ASSET_ENDPOINT, props.id), {
        cancelToken: signalToken,
      })
      .then((res) => {
        dispatch({
          type: DELETE_ASSET,
          payload: props.id,
        });
        dispatch(fetchBrandKits());
        resolve(res);
      })
      .catch((error) => {
        dispatch(errorHandlerActions.handleHTTPError(error, props.id));
        reject(error);
      });
  });
};

const deleteTemplate = (id, signalToken) => (dispatch) => {
  showToast({
    description: t("sidebar.deleting_temp", { ns: "navbar" }),
    title: t("sidebar.deleting_temp_title", { ns: "navbar" }),
    status: "info",
  });

  let data = { cancelToken: signalToken };
  return axios
    .delete(format(DELETE_TEMPLATE_ENDPOINT, id), data)
    .then((res) => {
      dispatch({
        type: DELETE_TEMPLATE,
        payload: id,
      });
      showToast({
        description: t("sidebar.temp_delete_success_msg", { ns: "navbar" }),
        title: t("success", { ns: "common" }),
        status: "success",
      });

      return res;
    })
    .catch((error) => {
      showToast({
        description: t("sidebar.temp_delete_failure", { ns: "navbar" }),
        title: t("failed", { ns: "common" }),
        status: "error",
      });

      dispatch(errorHandlerActions.handleHTTPError(error, id));
    });
};

const bulkAction =
  (props, endpoint, action, signalToken, dispatchType) => (dispatch) => {
    const ids = props.ids;
    axios
      .post(
        format(endpoint, "bulk"),
        { ids, action },
        { cancelToken: signalToken }
      )
      .then((res) => {
        ids.forEach((id) => {
          dispatch({
            type: dispatchType,
            payload: id,
          });
        });
      })
      .catch((error) => {
        dispatch(errorHandlerActions.handleHTTPError(error, props));
      });
  };

export const fetchTemplateGroups =
  (templateType, props, signalToken, formatFilter = undefined) =>
  (dispatch) => {
    let endpoint = format(GROUP_BY_CATEGORIES, templateType);
    let url = new URL(endpoint);

    if (formatFilter) {
      url.searchParams.append("format_size", formatFilter);
    }

    url.searchParams.append("page", props?.sidebarSlider?.page);

    axios
      .get(url.href, {
        signal: signalToken,
      })
      .then((res) => {
        dispatch({
          type: GET_TEMPLATE_GROUPS,
          payload: {
            data: res.data.results,
            groupKey: props.groupKey || 0,
            hasMore: res.data.next !== null,
          },
        });
      })
      .catch((error) => {
        dispatch(errorHandlerActions.handleHTTPError(error, props));
      });
  };

export const fetchViewAllTemplates =
  (
    templateType,
    props,
    signalToken,
    formatFilter,
    shouldValidateViewAllState = false
  ) =>
  (dispatch, getState) => {
    const { page, org, categoryId, creatorId, excludeCreatorId, status } =
      props;

    let endpoint = new URL(SEARCH_BY_TEMPLATE_TYPE);
    endpoint.searchParams.append("template", templateType);
    endpoint.searchParams.append("page", page);

    if (org) {
      endpoint.searchParams.append("org", org);
    }
    if (categoryId) {
      endpoint.searchParams.append("category_id", categoryId);
    }
    if (formatFilter && props.formatFilter !== false) {
      endpoint.searchParams.append("format_size", formatFilter);
    }

    if (creatorId) {
      endpoint.searchParams.append("creator_id", creatorId);
    }
    if (excludeCreatorId) {
      endpoint.searchParams.append("creator_id__exclude", excludeCreatorId);
    }

    if (status === 0 || status === 1) {
      endpoint.searchParams.append("status", status);
    }

    axios
      .get(endpoint.href, { signal: signalToken })
      .then((res) => {
        if (shouldValidateViewAllState && !getState().sidebarSlider?.viewAll) {
          // If view all panel is not open in the state then return;
          return;
        }

        dispatch({
          type: GET_ELEMENTS_VIEW_ALL,
          payload: {
            data: res.data.results,
            groupKey: props.groupKey || 0,
            type: props.type,
            hasMore: res.data.next ? true : false,
          },
        });
      })
      .catch((error) => {
        console.error(`Error in fetching ${props.type || "elements"}!`);
        dispatch(errorHandlerActions.handleHTTPError(error, props));
      });
  };

export const searchTemplateAll =
  (
    searchTerm,
    templateType,
    props,
    signalToken,
    formatFilter = undefined,
    shouldValidateViewAllState = false
  ) =>
  (dispatch, getState) => {
    const { groupKey, type, page } = props;

    let endpoint = new URL(SEARCH_BY_TEMPLATE_TYPE);
    endpoint.searchParams.append("template", templateType);
    endpoint.searchParams.append("page", page);
    endpoint.searchParams.append("search", searchTerm);

    if (formatFilter) {
      endpoint.searchParams.append("format_size", formatFilter);
    }
    if (props.org) {
      endpoint.searchParams.append("org", props.org);
    }
    if (props.categoryId) {
      endpoint.searchParams.append("category_id", props.categoryId);
    }
    axios
      .get(endpoint.href, { signal: signalToken })
      .then((res) => {
        if (shouldValidateViewAllState && !getState().sidebarSlider?.viewAll) {
          // If view all panel is not open in the state then return;
          return;
        }
        dispatch({
          type: SEARCH_ELEMENTS_ALL,
          payload: {
            data: res.data.results,
            groupKey: groupKey || 0,
            type: type,
            searchText: searchTerm,
            hasMore: res.data.next !== null,
          },
        });
      })
      .catch((error) => {
        dispatch(errorHandlerActions.handleHTTPError(error, props));
      });
  };

export const searchTemplateGroups =
  (
    searchTerm,
    templateType,
    groupBy,
    props,
    signalToken,
    formatFilter = undefined
  ) =>
  (dispatch) => {
    const { groupKey } = props;
    let endpoint = `${GROUP_BY_TEMPLATES}/groups?group_by=${groupBy}`;
    let url = new URL(endpoint);
    url.searchParams.append("template", templateType);
    url.searchParams.append("search", searchTerm);

    if (formatFilter) {
      url.searchParams.append("format_size", formatFilter);
    }

    axios
      .get(url.href, { signal: signalToken })
      .then((res) => {
        dispatch({
          type: SEARCH_ELEMENTS,
          payload: {
            data: res.data.results,
            groupKey: groupKey || 0,
            searchText: searchTerm,
          },
        });
      })
      .catch((error) => {
        dispatch(errorHandlerActions.handleHTTPError(error, props));
      });
  };

const executeNotPathFound = (searchTerm, props) => {};

export const deleteUserAssets = (props, token) => (dispatch) => {
  switch (props.type) {
    case "asset":
    case "brandAsset":
      return dispatch(deleteAsset(props, token));
    case "svg":
      return dispatch(deleteTemplate(props.id, token));
    case "document":
      return dispatch(deleteDocument(props.id, token));
    default:
      return executeNotPathFound();
  }
};

export const deleteItemsInBulk = (props, token) => (dispatch) => {
  let endpoint = "";
  let dispatchType = "";
  const ids = props.ids;

  switch (props.type) {
    case ContentTypes.ASSET:
    case "brandAsset":
      endpoint = DELETE_ASSET_ENDPOINT;
      dispatchType = DELETE_ASSET;
      break;
    case ContentTypes.TEAM_TEMPLATE:
      endpoint = DELETE_TEMPLATE_ENDPOINT;
      dispatchType = DELETE_TEMPLATE;
      break;
    case ContentTypes.STORY:
      endpoint = STORIES_DETAIL;
      dispatchType = DELETE_STORY;
      break;
    case ContentTypes.AI_DOCUMENT:
      endpoint = DELETE_DOCUMENTS_ENDPOINT;
      dispatchType = DELETE_DOCUMENT;
      break;
    default:
      return executeNotPathFound();
  }

  return new Promise((resolve, reject) => {
    axios
      .post(
        format(endpoint, "bulk"),
        { ids, action: "delete" },
        { cancelToken: token }
      )
      .then((res) => {
        ids.forEach((id) => {
          dispatch({
            type: dispatchType,
            payload: id,
          });
        });
        resolve(res.data);
      })
      .catch((error) => {
        dispatch(errorHandlerActions.handleHTTPError(error, props));
        reject(error);
      });
  });
};

export const search = (source, searchTerm, props) => (dispatch, getState) => {
  const { abortController } = getState().sidebarSlider;
  const signalToken = abortController.signal;
  const auth = getState().auth;
  props = { ...props, auth };
  switch (props.panelType) {
    case IMAGES_SLIDER_PANEL:
      return dispatch(
        searchImagesPerSource(source, searchTerm, props, signalToken)
      );
    case GIPHY_SLIDER_PANEL:
      return dispatch(searchGiphy(searchTerm, props, signalToken));
    case VIDEO_SLIDER_PANEL:
      return dispatch(
        searchVideosPerSource(source, searchTerm, props, signalToken)
      );
    case FONTS_COMBINATION_PANEL:
      return dispatch(fetchTextBlocks(props));

    case SAVED_ELEMENTS_PANEL:
      return dispatch(
        searchTemplateAll(searchTerm, "shape", props, signalToken)
      );
    case GRAPHICS_SLIDER_PANEL:
    case ELEMENTS_SLIDER_PANEL:
      if (props.categoryId) {
        return dispatch(
          searchTemplateAll(
            searchTerm,
            "shape",
            { ...props, org: null },
            signalToken,
            undefined,
            true
          )
        );
      }

      return dispatch(
        searchTemplateGroups(
          searchTerm,
          "shape",
          "category",
          { ...props, org: null },
          signalToken
        )
      );

    case SAVED_TEMPLATES_PANEL:
      return dispatch(
        searchTemplateAll(searchTerm, "template", props, signalToken)
      );
    case TEMPLATES_SLIDER_PANEL:
      const formatFilter = formatSize(props, props.contentSize);

      if (props.categoryId) {
        return dispatch(
          searchTemplateAll(
            searchTerm,
            "template",
            { ...props, org: null },
            signalToken,
            formatFilter
          )
        );
      }

      return dispatch(
        searchTemplateGroups(
          searchTerm,
          "template",
          "category",
          { ...props, orgs: null },
          signalToken,
          formatFilter
        )
      );
    case ICONS_SLIDER_PANEL:
      return dispatch(
        searchIconsPerSource(source, searchTerm, props, signalToken)
      );
    case MUSIC_SLIDER_PANEL:
      return dispatch(
        fetchMusicPerSource(source, searchTerm, props, signalToken)
      );
    case ASSETS_SLIDER_PANEL:
      props.titleSearchQuery = searchTerm;
      return dispatch(fetchAssets(props, signalToken));
    default:
      return executeNotPathFound();
  }
};

export const searchImagesPerSource =
  (imgSource, searchTerm, props, signalToken) => (dispatch) => {
    switch (imgSource) {
      case ImageSources.UNSPLASH:
        return dispatch(searchImages(searchTerm, props, signalToken));
      case ImageSources.PEXELS:
        return dispatch(searchImagesOnPexels(searchTerm, props, signalToken));
      case ImageSources.PIXABAY:
        return dispatch(searchImagesOnPixabay(searchTerm, props, signalToken));
      case ImageSources.SHOPIFY:
        return dispatch(
          searchImagesFromShopify(searchTerm, props, signalToken)
        );
      case ImageSources.GOOGLE_DRIVE:
        return dispatch(
          searchImagesFromGoogleDrive(searchTerm, props, signalToken)
        );
      case ImageSources.SHUTTERSTOCK:
        return dispatch(
          searchImagesOnShutterstock(searchTerm, props, signalToken)
        );
      case ImageSources.STORYBLOCKS:
        return dispatch(
          searchImagesOnStoryBlocks(searchTerm, props, signalToken)
        );
      default:
        return executeNotPathFound();
    }
  };

export const searchVideosPerSource =
  (imgSource, searchTerm, props, signalToken) => (dispatch) => {
    switch (imgSource) {
      case VideoSources.PIXABAY:
        return dispatch(fetchVideos(searchTerm, props, signalToken));
      case VideoSources.PEXELS:
        return dispatch(fetchVideosFromPexels(searchTerm, props, signalToken));
      case VideoSources.SHUTTERSTOCK:
        return dispatch(searchVideosOnShutterstock(searchTerm, props));
      case VideoSources.STORYBLOCKS:
        return dispatch(searchVideosOnStoryBlocks(searchTerm, props));
      default:
        return executeNotPathFound();
    }
  };

const searchIconsPerSource =
  (source, searchTerm, props, signalToken) => (dispatch) => {
    switch (source) {
      case IconsSources.FLATICON:
        return dispatch(searchIconsOnFlaticon(searchTerm, props, signalToken));
      case IconsSources.BRANDFETCH:
        return dispatch(
          searchIconsOnBrandfetch(searchTerm, props, signalToken)
        );
      case IconsSources.ICONS8:
        return dispatch(searchIcons8Icon(searchTerm, props, signalToken));
      case IconsSources.NOUN_PROJECT:
        return dispatch(searchNounProjectIcon(searchTerm, props, signalToken));
      default:
        return executeNotPathFound();
    }
  };

const fetchMusicPerSource =
  (source, searchTerm, props, signalToken) => (dispatch) => {
    switch (source) {
      case MusicSources.STORYBLOCKS:
        return dispatch(
          searchMusicOnStoryblocks(searchTerm, props, signalToken)
        );

      default:
        return executeNotPathFound();
    }
  };

export const fetchData = (source, props) => (dispatch, getState) => {
  const { abortController } = getState().sidebarSlider;
  const signalToken = abortController.signal;
  const auth = getState().auth;
  props = { ...props, auth };
  switch (props.panelType) {
    case IMAGES_SLIDER_PANEL:
      return dispatch(fetchDataPerSource(source, props, signalToken));
    case GIPHY_SLIDER_PANEL:
      return dispatch(fetchGiphy(props, signalToken));
    case VIDEO_SLIDER_PANEL:
      return dispatch(fetchVideoPerSource(source, props, signalToken));
    case FONTS_COMBINATION_PANEL:
      return dispatch(fetchTextBlocks(props, signalToken));
    case ASSETS_SLIDER_PANEL:
      return dispatch(fetchAssets(props, signalToken));

    case SAVED_TEMPLATES_PANEL:
      return dispatch(fetchViewAllTemplates("template", props, signalToken));
    case SAVED_ELEMENTS_PANEL:
      return dispatch(fetchViewAllTemplates("shape", props, signalToken));
    case GRAPHICS_SLIDER_PANEL:
      if (props?.categoryId) {
        return dispatch(
          fetchViewAllTemplates(
            "shape",
            {
              ...props,
              org: null,
            },
            signalToken,
            undefined,
            true
          )
        );
      }
      return dispatch(
        fetchTemplateGroups("shape", { ...props, org: null }, signalToken)
      );
    case TEMPLATES_SLIDER_PANEL:
      const formatFilter = formatSize(props, props.contentSize);

      if (props?.categoryId) {
        return dispatch(
          fetchViewAllTemplates(
            "template",
            { ...props, org: null },
            signalToken,
            formatFilter
          )
        );
      }

      return dispatch(
        fetchTemplateGroups(
          "template",
          { ...props, org: null },
          signalToken,
          formatFilter
        )
      );
    case ICONS_SLIDER_PANEL:
      return dispatch(fetchIconsPerSource(source, props, signalToken));
    case MUSIC_SLIDER_PANEL:
      return dispatch(fetchMusicPerSource(source, "", props, signalToken));
    default:
      return executeNotPathFound();
  }
};

export const fetchDataPerSource =
  (source, props, signalToken) => (dispatch) => {
    switch (source) {
      case ImageSources.UNSPLASH:
        return dispatch(fetchImages(props, signalToken));
      case ImageSources.PEXELS:
        return dispatch(fetchImagesFromPexels(props, signalToken));
      case ImageSources.PIXABAY:
        return dispatch(fetchImagesFromPixabay(props, signalToken));
      case ImageSources.SHOPIFY:
        return dispatch(searchImagesFromShopify(null, props, signalToken));
      case ImageSources.GOOGLE_DRIVE:
        return dispatch(searchImagesFromGoogleDrive(null, props, signalToken));
      case ImageSources.SHUTTERSTOCK:
        return dispatch(searchImagesOnShutterstock(null, props, signalToken));
      case ImageSources.STORYBLOCKS:
        return dispatch(searchImagesOnStoryBlocks(null, props, signalToken));
      default:
        return executeNotPathFound();
    }
  };

export const fetchVideoPerSource =
  (source, props, signalToken) => (dispatch) => {
    switch (source) {
      case VideoSources.PIXABAY:
        return dispatch(fetchVideos("people", props, signalToken));
      case VideoSources.PEXELS:
        return dispatch(fetchVideosFromPexels("people", props, signalToken));
      case VideoSources.SHUTTERSTOCK:
        return dispatch(searchVideosOnShutterstock("", props, signalToken));
      case VideoSources.STORYBLOCKS:
        return dispatch(searchVideosOnStoryBlocks("", props, signalToken));
      default:
        return executeNotPathFound();
    }
  };

const fetchIconsPerSource = (source, props, signalToken) => (dispatch) => {
  switch (source) {
    case IconsSources.FLATICON:
      return dispatch(fetchAllIconsFromFlaticon(props, signalToken));
    case IconsSources.BRANDFETCH:
      return dispatch(searchIconsOnBrandfetch("google", props, signalToken));
    case IconsSources.ICONS8:
      return dispatch(fetchIcons8Icon(props, signalToken));
    case IconsSources.NOUN_PROJECT:
      return dispatch(searchNounProjectIcon(undefined, props, signalToken));
    default:
      return executeNotPathFound();
  }
};

export const publishTemplate =
  (templateId, payload, signalToken) => (dispatch) => {
    showToast({
      description: t("sidebar.publish_temp_msg", { ns: "navbar" }),
      title: t("sidebar.publish_temp_title", { ns: "navbar" }),
      status: "info",
    });

    return axios
      .put(format(PUBLISH_TEMPLATE, templateId), payload, {
        cancelToken: signalToken.token,
      })
      .then((res) => {
        if (res.status === 200) {
          showToast({
            description: t("sidebar.publish_temp_success", { ns: "navbar" }),
            title: t("sidebar.publish_temp_process", { ns: "navbar" }),
            status: "success",
          });

          dispatch({
            type: TEMPLATE_PUBLISHED,
          });
          return res;
        }
      })
      .catch((error) => {
        showToast({
          description: t("sidebar.publish_temp_failed", { ns: "navbar" }),
          title: t("failed", { ns: "common" }),
          status: "error",
        });

        dispatch(errorHandlerActions.handleHTTPError(error));
      });
  };

export const handleRenameAsset = (id, reqPayload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`${ASSETS_ENDPOINT}/${id}`, reqPayload)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
        dispatch(errorHandlerActions.handleHTTPError(error));
      });
  });
};
